<template>
    <v-card>
        <v-card-title>
            Event: {{event_obj.title}}
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('close_checkings')">
                <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-subtitle>
            Check-Ins
        </v-card-subtitle>
        <v-card-text>

            <v-row>
                <v-col xs4>
                    <v-btn color="success" @click="checkinAttendee()">Start Check-ins</v-btn>
                </v-col>
                <v-col xs8>
                    <v-spacer></v-spacer>
                    <v-text-field label="search" v-model="search" prepend-icon="search"></v-text-field>
                </v-col>
            </v-row>
            <v-data-table :headers="headers" :loading="loading" :items="checkins?checkins:[]" :search="search">
                <template v-slot:item.checkin_count="{ item }">
                    <v-chip :color="item.checkin_count>0?'success':'error'">{{item.checkin_count}}</v-chip>
                </template> 
                <!-- <template v-slot:item.actions="{ item }">
                    <v-icon color="error" @click="undoCheckin(item)">
                        delete
                    </v-icon>
                </template> -->
            </v-data-table>
            <v-dialog v-model="readQrCode" persistent>
                <v-card>
                    <v-card-title>
                        Check-in
                        <v-spacer></v-spacer>
                        <v-btn @click="closeScanner()" icon>
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-subtitle>Scan QrCode on ticket to check attendee in.</v-card-subtitle>
                    <v-card-text class="text-center">
                        <qrcode-stream @decode="onDecode" v-if="scan" @init="onInit"></qrcode-stream>
                        <v-btn @click="scan=!scan" v-else color="warning" :loading="loading">New Scan</v-btn>
                    </v-card-text>
                </v-card>

            </v-dialog>
        </v-card-text>
    </v-card>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import { db } from '../../config/firebasedb'
export default {
    props: {
        event_obj: Object
    },
    components: {
        QrcodeStream
    },
    data: () => ({
        search: "",
        loading: false,
        readQrCode: false,
        scan: false,
        checkinLoading: false,
        error: "",
        headers: [
            {
                text: 'Name',
                align: 'start',
                sortable: false,
                value: 'name',
            },
            { text: 'E-mail', value: 'email' },
            { text: 'Phone', value: 'phone' },
            { text: 'Company', value: 'company_name' },
            { text: 'Check-in Dates', value: 'checkin_dates' },
            { text: 'Check-in count', value: 'checkin_count' },
        ],
        checkins: [
            // {
            //     name: "Emmanuel Boahen",
            //     email: "emmaboahen6@gmail.com",
            //     phone: "0506340523",
            //     company_name: "Inclusive Tech Group",
            //     checkin_date: "30th June, 2022 @ 8:35 am"
            // }
        ]
    }),
    async created() {
        this.loading = true
        await db.collection("events")
            .doc(this.event_obj.id)
            .collection("registrations")
            .onSnapshot(snap => {
                this.checkins = []
                snap.forEach(doc => {
                    var checkin = doc.data()
                    checkin.id = doc.id
                    checkin.checkin_count = checkin.checkin_dates.length
                    checkin.checkin_dates = checkin.checkin_dates.map(d=>new Date(d).toDateString()+' @ '+new Date(d).toLocaleTimeString())
                    this.checkins.unshift(checkin)
                })
                this.loading = false
            })
    },
    methods: {
        async onDecode(decodedString) {
            this.loading = true
            this.scan = false
            var newDate = new Date();
            var checkinDateTime = newDate.toISOString()
            var currentReg = this.checkins.find(ch=>ch.id==decodedString);
            var previousCheckinDates = currentReg?.checkin_dates
            if(previousCheckinDates&&new Date(previousCheckinDates[0]).toLocaleDateString()==newDate.toLocaleDateString()){
                this.$toast.warning(`${currentReg.name} has already checked-in today`,{duration:4000})
                this.loading = false
                return
            }
            await db.collection("events")
                .doc(this.event_obj.id)
                .collection("registrations")
                .doc(decodedString)
                .update({
                    checkin_dates: [checkinDateTime,...previousCheckinDates]
                }).then(() => {
                    this.$toast.success(`${currentReg.name} has been check-in successfully`,{duration:4000})
                }).catch(err => {
                    console.log(err)
                    this.$toast.error("An error occured and check-in was not successful")
                })
            this.loading = false

        },
        async onInit(promise) {
            try {
                await promise
            } catch (error) {
                if (error.name === 'NotAllowedError') {
                    this.error = "ERROR: you need to grant camera access permission"
                } else if (error.name === 'NotFoundError') {
                    this.error = "ERROR: no camera on this device"
                } else if (error.name === 'NotSupportedError') {
                    this.error = "ERROR: secure context required (HTTPS, localhost)"
                } else if (error.name === 'NotReadableError') {
                    this.error = "ERROR: is the camera already in use?"
                } else if (error.name === 'OverconstrainedError') {
                    this.error = "ERROR: installed cameras are not suitable"
                } else if (error.name === 'StreamApiNotSupportedError') {
                    this.error = "ERROR: Stream API is not supported in this browser"
                } else if (error.name === 'InsecureContextError') {
                    this.error = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
                } else {
                    this.error = `ERROR: Camera error (${error.name})`;
                }
                alert(this.error)
                this.closeScanner()
            }
        },
        checkinAttendee() {
            this.scan = true
            this.readQrCode = !this.readQrCode
        },
        // async undoCheckin(registration) {
        //     if (confirm("Are you sure you want to delete this check-in?")) {
        //         this.loading = true
        //         await db.collection("events")
        //             .doc(this.event_obj.id)
        //             .collection("registrations")
        //             .doc(registration.id)
        //             .update({
        //                 checkin_status: "pending",
        //                 checkin_date: ""
        //             }).then(() => {
        //                 this.$toast.success("Check-in deleted successfully")
        //             }).catch(err => {
        //                 console.log(err)
        //                 this.$toast.error("An error occured and check-in could not be deleted")
        //             })
        //         this.loading = false
        //     }

        // },
        closeScanner() {
            this.readQrCode = false
            this.scan = false
        }
    }
}
</script>
